import React, { useState, useEffect } from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import ChillerChangeHistoryRow from '../../../chillerModules/chillerLogs/components/ChillerChangeHistoryRow';
import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';

import { BackflowJobItem } from '../../model';
import { HistoryItem } from '../../../salesEstimateModules/estimateRebates/model';

import axios from '../../../sharedModules/utils/axios.utils';

interface JobItemHistoryProps {
  backflowJobItem: BackflowJobItem;
}

const JobItemHistory: React.FC<JobItemHistoryProps> = (props) => {
  const { backflowJobItem } = props;

  const [errorMessage, setErrorMessage] = useState<string>('');
  const [historyItems, setHistoryItems] = useState<HistoryItem[]>([]);

  const fetchHistoryItems = async () => {
    try {
      const response: any = await axios.get('/history_items', {
        params: {
          historyable_id: backflowJobItem.id,
          historyable_type: 'BackflowJobItem',
        },
      });
      setHistoryItems(response.data.result);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Error fetching history items');
    }
  };

  useEffect(() => {
    if (backflowJobItem?.id && historyItems.length === 0) {
      fetchHistoryItems();
    }
  }, [backflowJobItem]);

  return (
    historyItems?.length > 0 && (
      <Accordion style={{ backgroundColor: 'bisque' }}>
        <AccordionSummary>
          {errorMessage ? (
            <ErrorMessage message={errorMessage} />
          ) : (
            <Typography variant="h5" component="h2">
              Changes to Backflow Device
            </Typography>
          )}
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2} style={{ padding: '1% 2%' }}>
            {historyItems?.map((historyItem, index) => {
              let backgroundColor = index % 2 === 0 ? 'lightgray' : 'white';

              return (
                <ChillerChangeHistoryRow
                  key={`history-item-${historyItem.id}`}
                  historyItem={historyItem}
                  backgroundColor={backgroundColor}
                />
              );
            })}
          </Grid>
        </AccordionDetails>
      </Accordion>
    )
  );
};

export default JobItemHistory;
